export interface PurchaseReturnState {
  purchase: any | null;
  loadingPurchase: boolean;
  supplierPurchases: any[];
  supplierPurchasesTotal: number;
  supplierPurchasesPage: number;
  loadingSupplierPurchases: boolean;
  error: any;
}

export const initialPurchaseReturnState: PurchaseReturnState = {
  purchase: null,
  loadingPurchase: false,
  supplierPurchases: [],
  supplierPurchasesTotal: 0,
  supplierPurchasesPage: 1,
  loadingSupplierPurchases: false,
  error: null,
};